import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
export function traceManageDomainButtonClick() {
    logUsage(datapoints.DomainDashboardManageDomain.datapoint.name, null, null, datapoints.DomainDashboardGetStarted.datapoint.options);
}
export function traceRemoveDomainButtonClick() {
    logUsage(datapoints.DomainDashboardRemoveDomain.datapoint.name, null, null, datapoints.DomainDashboardGetStarted.datapoint.options);
}
export function traceCreateEmailButtonClick() {
    logUsage(datapoints.DomainDashboardCreateEmail.datapoint.name, null, null, datapoints.DomainDashboardGetStarted.datapoint.options);
}
export function traceStartEnrollDomainClick() {
    logUsage(datapoints.DomainDashboardGetStarted.datapoint.name, null, null, datapoints.DomainDashboardGetStarted.datapoint.options);
}
export function traceDomainStatus(message) {
    logUsage(datapoints.DomainDashboarDomainStatus.datapoint.name, datapoints.DomainDashboarDomainStatus.datapoint.customData(message.domainData.dnsRecordValue, message.domainData.domainName, message.domainData.isDomainValidated, message.domainData.isDomainExisted, message.domainData.domainPurchaseType.toString(), message.domainData.domainPurchaseDate.toString()), null, datapoints.DomainDashboarDomainStatus.datapoint.options);
}
export function traceDomainUIStatue(isAliasAdded, uiState) {
    logUsage(datapoints.DomainDashboarDomainUIStatus.datapoint.name, datapoints.DomainDashboarDomainUIStatus.datapoint.customData(isAliasAdded, uiState), null, datapoints.DomainDashboarDomainUIStatus.datapoint.options);
}
//# sourceMappingURL=domainOptionTracer.js.map